import { render } from "./CurrencyCirculationIcon.vue?vue&type=template&id=268c36c8"
import script from "./CurrencyCirculationIcon.vue?vue&type=script&lang=js"
export * from "./CurrencyCirculationIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__